// mbscan manager-client へ同じ形で移植する予定（移植までは mbfab のみ）。移植後は片側だけで変えない

import { useCallback, useState } from 'react'

import { canonicalizeFilterBarValue } from './filter-bar-url-state'

/**
 * 絞り込み条件に紐づくページ番号。条件が変わると 1 ページ目に戻る。
 * 条件の変更経路（入力・チップ解除・ブラウザの戻る/進むによる URL 変更）ごとに setPage(1) を書くと、
 * URL 由来の変更で書き漏れて「新しい条件で 3 ページ目」を取りに行ってしまうため、条件の値そのものに紐づける
 */
export function useFilterScopedPage(conditions: unknown): [number, (page: number) => void] {
  const key = canonicalizeFilterBarValue(conditions)
  const [state, setState] = useState({ page: 1, key })
  const setPage = useCallback(
    (page: number) => {
      setState({ page, key })
    },
    [key],
  )
  return [state.key === key ? state.page : 1, setPage]
}
